// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Category = require("../Control.Category/index.js");
var Control_Monad_Free = require("../Control.Monad.Free/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Framework_Render_Color = require("../Framework.Render.Color/index.js");
var Image = function (x) {
    return x;
};
var LoadImage = (function () {
    function LoadImage(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    LoadImage.create = function (value0) {
        return function (value1) {
            return new LoadImage(value0, value1);
        };
    };
    return LoadImage;
})();
var GetDimensions = (function () {
    function GetDimensions(value0) {
        this.value0 = value0;
    };
    GetDimensions.create = function (value0) {
        return new GetDimensions(value0);
    };
    return GetDimensions;
})();
var FillRect = (function () {
    function FillRect(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    FillRect.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new FillRect(value0, value1, value2);
            };
        };
    };
    return FillRect;
})();
var DrawImage = (function () {
    function DrawImage(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    DrawImage.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new DrawImage(value0, value1, value2);
            };
        };
    };
    return DrawImage;
})();
var DrawImageFull = (function () {
    function DrawImageFull(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    };
    DrawImageFull.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return function (value3) {
                    return new DrawImageFull(value0, value1, value2, value3);
                };
            };
        };
    };
    return DrawImageFull;
})();
var DrawLine = (function () {
    function DrawLine(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    DrawLine.create = function (value0) {
        return function (value1) {
            return new DrawLine(value0, value1);
        };
    };
    return DrawLine;
})();
var renderF = new Data_Functor.Functor(function (f) {
    return function (m) {
        if (m instanceof LoadImage) {
            return new LoadImage(m.value0, Data_Functor.map(Data_Functor.functorFn)(f)(m.value1));
        };
        if (m instanceof GetDimensions) {
            return new GetDimensions(Data_Functor.map(Data_Functor.functorFn)(f)(m.value0));
        };
        if (m instanceof FillRect) {
            return new FillRect(m.value0, m.value1, f(m.value2));
        };
        if (m instanceof DrawImage) {
            return new DrawImage(m.value0, m.value1, f(m.value2));
        };
        if (m instanceof DrawImageFull) {
            return new DrawImageFull(m.value0, m.value1, m.value2, f(m.value3));
        };
        if (m instanceof DrawLine) {
            return new DrawLine(m.value0, f(m.value1));
        };
        throw new Error("Failed pattern match at Framework.Render.Core (line 33, column 1 - line 33, column 43): " + [ m.constructor.name ]);
    };
});
var loadImage = function (path) {
    return Control_Monad_Free.liftF(new LoadImage(path, Control_Category.identity(Control_Category.categoryFn)));
};
var getDimensions = Control_Monad_Free.liftF(new GetDimensions(Control_Category.identity(Control_Category.categoryFn)));
var fillRect = function (color) {
    return function (rect) {
        return Control_Monad_Free.wrap(new FillRect(color, rect, Control_Applicative.pure(Control_Monad_Free.freeApplicative)(Data_Unit.unit)));
    };
};
var drawLine = function (c) {
    return Control_Monad_Free.wrap(new DrawLine(c, Control_Applicative.pure(Control_Monad_Free.freeApplicative)(Data_Unit.unit)));
};
var drawImageFull = function (image) {
    return function (srcRect) {
        return function (destRect) {
            return Control_Monad_Free.wrap(new DrawImageFull(image, srcRect, destRect, Control_Applicative.pure(Control_Monad_Free.freeApplicative)(Data_Unit.unit)));
        };
    };
};
var drawImage = function (image) {
    return function (rect) {
        return Control_Monad_Free.wrap(new DrawImage(image, rect, Control_Applicative.pure(Control_Monad_Free.freeApplicative)(Data_Unit.unit)));
    };
};
var clearRegion = fillRect(Framework_Render_Color.black);
var clear = Control_Bind.bind(Control_Monad_Free.freeBind)(getDimensions)(function (v) {
    return fillRect(Framework_Render_Color.black)({
        x: 0.0,
        y: 0.0,
        width: v.width,
        height: v.height
    });
});
module.exports = {
    Image: Image,
    LoadImage: LoadImage,
    GetDimensions: GetDimensions,
    FillRect: FillRect,
    DrawImage: DrawImage,
    DrawImageFull: DrawImageFull,
    DrawLine: DrawLine,
    getDimensions: getDimensions,
    fillRect: fillRect,
    loadImage: loadImage,
    drawImage: drawImage,
    drawImageFull: drawImageFull,
    drawLine: drawLine,
    clear: clear,
    clearRegion: clearRegion,
    renderF: renderF
};
